import React from 'react';
import { Handle,Position } from 'reactflow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Icons from "../Icons";
const isNodeDataComplete = (data,metadata) => {
  if (!metadata) {
    return true;
  }
  for (const field of metadata) {
    if (field.required && (data[field.name] === undefined || data[field.name] === null || data[field.name] === '')) {
      return false;
    }
  }
  return true;
};

const Node =  ({nodeName, data, id,selected,metadata,type,style={}}) => {
  let isComplete = isNodeDataComplete(data,metadata);

  let statusClass;
  if(data.disabled){
    statusClass = 'node-disabled';
  }else{
    statusClass = ((data||{}).nodeState||{}).status ? `node-status-${((data||{}).nodeState||{}).status}` : 'node-status-pending';
  }
  return (
    <div style={{ border: '1px solid #ccc', padding: 10, ...style }} className={`base-node ${statusClass} ${selected ? 'selected-node' : ''}`}>
      <Handle type="target"
        position={Position.Left}
        onConnect={(params) => console.log('handle onConnect', params)}
        isConnectable={true}
      />
      {!isComplete && <div className="node-warning">⚠️</div>} {/* Biểu tượng cảnh báo */}
      
      <div style={{display:"flex",flexDirection:"row",alignItems:"center"}}>
        <FontAwesomeIcon icon={Icons[type] || Icons.default} className="node-icon" style={{color:style.color}} />
        <div>
          <div style={{ textAlign:"center" }} className="name-node">{nodeName || data.name||"Báo cáo"}</div>
          {/* Hiển thị trạng thái nếu có */}
          {((data||{}).nodeState||{}).status && <div  className="status-node">{((data||{}).nodeState||{}).status}</div>}
        </div>
      </div>

      

      
      
      
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        isConnectable={true}
      />
      
    </div>
  );
};

export default Node; 